import convertToDayjs from './convertToDayjs';

const convertToDayjsStartOf = (
  date: Date | string,
  startOf: string = 'minute'
) => convertToDayjs(date).startOf(startOf);

export default convertToDayjsStartOf;
